import LatestYearBySourceContainer from './LatestYearBySourceContainer';

export default LatestYearBySourceContainer;
